import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';


export default class OrganizationDetailEditButtons extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let editPageButton = <button onClick={this.props.showPageEdit}>Edit your page</button>;
    let editThumbButton = <button onClick={this.props.showThumbEdit}>Edit thumbnail</button>;
    let editAccountButton = <button onClick={this.props.showAccountEdit}>Edit admin account</button>;

    switch (this.props.editMode) {
      case 'account':
        editAccountButton = <button onClick={this.props.saveOrganization} className="button-primary">Done editing admin account</button>;
        break;
      case 'thumb':
        editThumbButton = <button onClick={this.props.saveOrganization} className="button-primary">Done editing thumbnail</button>;
        break;
      default:
        editPageButton = <button onClick={(e) => this.props.saveOrganization(e, true)} className="button-primary">Save your edited page</button>;
        break;
    }

    return  <div className="organizationDetail-editButtons">
      <Link onClick={this.props.goBackFromEdit} className="button" to={`/organizations/${this.props.organization.db_id}`}><i className="fa fa-chevron-left" ></i> Go back</Link>
      {editPageButton}
      {editThumbButton}
      {editAccountButton}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailEditButtons.jsx